<div class="post-details">
  <div class="details">
    <fa-icon
      [icon]="['fas', 'times-circle']"
      class="close-details"
      (click)="closeDetails()"
    ></fa-icon>
    <div class="thumbnail" *ngIf="post && post.thumbnail_big">
      <img [src]="post.thumbnail_big" appFallbackImage appLazyLoad />
    </div>
    <div class="content">
      <div class="source" *ngIf="post && post.source">
        <img [src]="post.source.icon_url" appFallbackImage appLazyLoad />
        {{ post.source.title }}
      </div>
      <div class="title" *ngIf="post">
        <h4 [innerHTML]="post.title"></h4>
      </div>
      <div class="post-info">
        <div
          class="sentiment {{
            post?.post_sentiment_algorithm_list[0].sentiment_id ==
            NomSentiment.NEUTRAL
              ? 'neutral'
              : post?.post_sentiment_algorithm_list[0].sentiment_id ==
                  NomSentiment.POSITIVE
                ? 'positive'
                : 'negative'
          }}"
        >
          {{ post?.post_sentiment_algorithm_list[0].title }}
        </div>
        <div class="post-date" *ngIf="post && post.publish_time">
          {{ post.publish_time.absolute }} ({{ post.publish_time.relative }})
        </div>
      </div>
      <div class="language">
        {{ post?.language.title }}
      </div>
    </div>
    <!-- <div class="thumb" [ngStyle]="{ 'background-image': backgroundStyle }"></div> -->
  </div>

  <ul class="nav nav-tabs">
    <li class="nav-item" *ngFor="let tab of tabs; let i = index">
      <a
        class="nav-link"
        [ngClass]="{ active: tab.active }"
        (click)="selectTab(tab, i)"
        *ngIf="tab.visible"
        >{{ tab.label }}</a
      >
    </li>
  </ul>
  <ng-container #tabContent></ng-container>
</div>
